import { Component } from '@angular/core';

import { MyApp } from '../../app/app.component';
import { APP_ROUTES_SERVICE } from '../../app/app.routes';
import { UsuarioService } from '../../providers/usuario-service';
import { GestaoPcaService } from '../../providers/gestao-pca-service';
import $ from "jquery";
import { Subscription } from 'rxjs';

@Component({
  selector: 'nav-bar',
  templateUrl: 'nav-bar.html',
  providers: [
    APP_ROUTES_SERVICE
  ]
})
export class NavBarComponent {
  listaPaginas: any[] = [];
  public menuAberto = false;
  usuario: any;
  usuarioLogado: boolean = false;
  subscription: Subscription;
  PCA: any;
  isPCASelecionada: any = false;

  constructor(public app: MyApp,
    private rotas: APP_ROUTES_SERVICE,
    private usuarioService: UsuarioService,
    private gestaoPcaService: GestaoPcaService) {

    this.listaPaginas = this.rotas.obtemListaRotaParaMontarMenu();

    usuarioService.usuarioSetado.subscribe(dadosUsuario => {
      this.usuario = dadosUsuario.usr;
      this.usuarioLogado = dadosUsuario.logado;
    });

    gestaoPcaService.getPCAObservable().subscribe(broadcastVariable => {
      this.isPCASelecionada = broadcastVariable.selecionada;
      if (this.isPCASelecionada) {
        this.PCA = broadcastVariable.PCA;
      }
    });
  }

  mudaPagina(pagina) {
    this.app.openPage(pagina);
    $('.bar-button-menutoggle-md').click();
  }

  usuarioPossuiAutorizacao(pagina) {
    if (this.usuario != null && this.usuario.permissoes != null) {

      if (pagina.Autorizacao == "*") {
        return true;
      }

      let autorizacao = this.usuario.permissoes.filter(permissao => permissao.nmOrdem == pagina.Autorizacao)[0];
      return autorizacao != null;
    }

    return false;
  }

  validarNecessidadeDePCA(pagina) {
    return !pagina.NecessarioPCA || (pagina.NecessarioPCA && this.isPCASelecionada);
  }
}



// WEBPACK FOOTER //
// ./src/components/nav-bar/nav-bar.ts